






































































































































import IListCurrency from '@/store/models/IListCurrency';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class ListCurrencySelector extends Vue {
    searchListCurrency: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name', value: 'name' },
        { text: 'Symbol', value: 'symbol' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IListCurrency = {
        id: "",
        name: "",
        symbol: "",
        idCompany: ""
    }
    defaultItem : IListCurrency = {
        id: "",
        name: "",
        symbol: "",
        idCompany: ""
    }

    @Prop({ type: Array, required: true })
    ListCurrencyList !: IListCurrency[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedListCurrency : IListCurrency[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Currency' : 'Edit Currency'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetListCurrency() {
        this.selectedListCurrency = [];
    }

    editListCurrency (item: any, dbox = true) {
        this.editedIndex = this.ListCurrencyList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveListCurrency () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedListCurrency[0]) {
                this.close();
                this.$emit('editListCurrency', this.editedItem);
                Object.assign(this.ListCurrencyList[this.editedIndex], this.editedItem);
            } else {
                this.selectedListCurrency[0] = this.editedItem;
                this.$emit('saveListCurrency', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteListCurrency (phonePrefix: IListCurrency) {
        this.$emit('deleteListCurrency', phonePrefix);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectListCurrency(item : any) : void {
        if (!this.selectedListCurrency.includes(item)) {
            this.selectedListCurrency = [];
            this.selectedListCurrency = [item];
        } else {
            this.selectedListCurrency = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
